'use client';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { dealLng } from '@/utils';
import { Image } from '@nextui-org/react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useCallback, useState } from 'react';

interface IProps {
  bookList: {
    _id: string;
    _urlId: string;
    title: string;
    coverPath: string;
  }[];
  length: number;
}

export default function BookList(props: IProps) {
  const [list, setList] = useState(props.bookList.slice(0, props.length));
  const [firstIndex, setFirstIndex] = useState(0);
  const params = useParams();

  const handleClick = useCallback((type: 'prev' | 'next', index: number) => {
    let curIndex = index;
    if (type === 'prev' && index > 0) {
      curIndex = index - 1;
      setFirstIndex(curIndex);
      setList(props.bookList.slice(curIndex, curIndex + props.length));
      return;
    }

    if (type === 'next' && index + props.length < props.bookList.length) {
      curIndex = index + 1;
      setFirstIndex(curIndex);
      setList(props.bookList.slice(curIndex, curIndex + props.length));
    }
  }, [setFirstIndex, props.length, props.bookList, setList]);

  return (
    <div className='flex items-center'>
      <div
        className='flex w-10 h-10 bg-black items-center justify-center rounded-md cursor-pointer'
        onClick={() => handleClick('prev', firstIndex)}
      >
        <Image
          src={MindfulAudioImg.LeftArrow}
          alt='prev'
          width={19}
          height={19}
          // className={clsx('shrink-0', firstIndex === 0 ? 'cursor-not-allowed' : 'cursor-pointer')}
          radius='none'
        />
      </div>

      <div className="book-img flex">
        {
          list.map(book => {
            return (
              <div className="book-item shrink flex flex-col mr-5 first:ml-5 last:mr-5 " key={book._id}>
                <Link href={`${dealLng(params.lng as string)}/book/${ book._urlId }`}>
                <Image src={book.coverPath} alt={book.title} radius='none' className='rounded-r-xl bg-cover object-fill w-[172px] h-[258px]' />
                </Link>
                <p className='text-16-22 max-w-[156px] pt-2'>{book.title}</p>
              </div>
            );
          })
        }
      </div>
      <div
        className='flex w-10 h-10 bg-black items-center justify-center rounded-md cursor-pointer'
        onClick={() => handleClick('next', firstIndex)}
      >
        <Image
          src={MindfulAudioImg.RightArrow}
          alt='prev'
          width={19}
          height={19}
          // className={clsx('shrink-0', firstIndex === 0 ? 'cursor-not-allowed' : 'cursor-pointer')}
          radius='none'
        />
      </div>
    </div>
  );
}
